'use strict';

module.exports = require('../services/createErrorClass')({
	name: 'UserHasActiveSubscription',
	message: 'You cannot link that user because they already have an active or pending subscription.',
	soft: true
});
